import React from 'react';
import { Container, Card, Table, Badge } from 'react-bootstrap';

const StaffTimetable = () => {
  // Sample data for the timetable
  const timetableData = {
    Monday: [
      { time: '09:00 - 10:00', subject: 'Computer Science 101', class: 'CS-A' },
      { time: '11:00 - 12:00', subject: 'Data Structures', class: 'CS-B' },
    ],
    Tuesday: [
      { time: '10:00 - 11:00', subject: 'Algorithms', class: 'IT-A' },
    ],
    Wednesday: [
      { time: '09:00 - 10:00', subject: 'Computer Science 101', class: 'CS-A' },
      { time: '02:00 - 03:00', subject: 'Lab: Data Structures', class: 'CS-B Lab' },
    ],
    Thursday: [
      { time: '11:00 - 12:00', subject: 'Data Structures', class: 'CS-B' },
    ],
    Friday: [
      { time: '10:00 - 11:00', subject: 'Algorithms', class: 'IT-A' },
      { time: '02:00 - 03:00', subject: 'Lab: Algorithms', class: 'IT-A Lab' },
    ],
    Saturday: [],
  };

  const days = Object.keys(timetableData);

  return (
    <Container fluid>
      <h1 className="mt-4">My Timetable</h1>
      <p>Your weekly teaching schedule.</p>
      <Card className="shadow-sm">
        <Card.Body>
          <Table bordered responsive className="text-center align-middle">
            <thead className="table-light">
              <tr>
                <th style={{width: '15%'}}>Day</th>
                <th>Schedule</th>
              </tr>
            </thead>
            <tbody>
              {days.map(day => (
                <tr key={day}>
                  <td className="fw-bold">{day}</td>
                  <td className="text-start">
                    {timetableData[day].length > 0 ? (
                      timetableData[day].map((slot, index) => (
                        <div key={index} className={`p-2 ${index < timetableData[day].length - 1 ? 'border-bottom' : ''}`}>
                          <Badge bg="primary" className="me-3 p-2">{slot.time}</Badge>
                          <span className="fw-semibold">{slot.subject}</span>
                          <span className="text-muted ms-2">({slot.class})</span>
                        </div>
                      ))
                    ) : (
                      <div className="p-2 text-muted">No classes scheduled</div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default StaffTimetable;